import {
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonAvatar,
  IonSkeletonText
} from '@ionic/react';

import classes from './style.module.scss';

const ListLoader = () => {
  return (
    <div className={classes.workoutDecWorkouts}>
      <div>
        <IonSkeletonText animated style={{ height: 30 }} />
      </div>
      <div className={classes.workoutWorkouts}>
        <IonList lines='none'>
          <IonItem color='primary'>
            <IonAvatar slot='start'>
              <IonSkeletonText animated />
            </IonAvatar>
            <IonLabel>
              <div className={classes.workoutWorkoutTitle}>
                <IonSkeletonText animated />
                <IonSkeletonText
                  animated
                  style={{ width: '40%', marginTop: 10 }}
                />
              </div>
            </IonLabel>
          </IonItem>
          <IonItem color='primary'>
            <IonAvatar slot='start'>
              <IonSkeletonText animated />
            </IonAvatar>
            <IonLabel>
              <div className={classes.workoutWorkoutTitle}>
                <IonSkeletonText animated />
                <IonSkeletonText
                  animated
                  style={{ width: '40%', marginTop: 10 }}
                />
              </div>
            </IonLabel>
          </IonItem>
          <IonItem color='primary'>
            <IonAvatar slot='start'>
              <IonSkeletonText animated />
              <IonSkeletonText
                animated
                style={{ width: '40%', marginTop: 10 }}
              />
            </IonAvatar>
            <IonLabel>
              <div className={classes.workoutWorkoutTitle}>
                <IonSkeletonText animated />
                <IonSkeletonText
                  animated
                  style={{ width: '40%', marginTop: 10 }}
                />
              </div>
            </IonLabel>
          </IonItem>
          <IonItem color='primary'>
            <IonAvatar slot='start'>
              <IonSkeletonText animated />
            </IonAvatar>
            <IonLabel>
              <div className={classes.workoutWorkoutTitle}>
                <IonSkeletonText animated />
                <IonSkeletonText
                  animated
                  style={{ width: '40%', marginTop: 10 }}
                />
              </div>
            </IonLabel>
          </IonItem>
          <IonItem color='primary'>
            <IonAvatar slot='start'>
              <IonSkeletonText animated />
            </IonAvatar>
            <IonLabel>
              <div className={classes.workoutWorkoutTitle}>
                <IonSkeletonText animated />
                <IonSkeletonText
                  animated
                  style={{ width: '40%', marginTop: 10 }}
                />
              </div>
            </IonLabel>
          </IonItem>
          <IonItem color='primary'>
            <IonAvatar slot='start'>
              <IonSkeletonText animated />
            </IonAvatar>
            <IonLabel>
              <div className={classes.workoutWorkoutTitle}>
                <IonSkeletonText animated />
                <IonSkeletonText
                  animated
                  style={{ width: '40%', marginTop: 10 }}
                />
              </div>
            </IonLabel>
          </IonItem>
          <IonItem color='primary'>
            <IonAvatar slot='start'>
              <IonSkeletonText animated />
            </IonAvatar>
            <IonLabel>
              <div className={classes.workoutWorkoutTitle}>
                <IonSkeletonText animated />
                <IonSkeletonText
                  animated
                  style={{ width: '40%', marginTop: 10 }}
                />
              </div>
            </IonLabel>
          </IonItem>
        </IonList>
      </div>
    </div>
  );
};

export default ListLoader;
